/**
 * Compact EUR display for pipeline totals (e.g. €120 k, €1.2 M).
 */
export function formatPipelineCompactEur(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  const v = value;
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `€${(v / 1_000_000).toFixed(1)} M`;
  if (abs >= 1000) return `€${(v / 1000).toFixed(0)} k`;
  return `€${v.toFixed(0)}`;
}

/** Axis / table amounts in thousands */
export function formatEurThousands(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  const k = value / 1000;
  if (Math.abs(k) >= 1000) return `€${(k / 1000).toFixed(1)} M`;
  return `€${k.toFixed(0)}k`;
}
